<template>
  <div class="m-currency-tips">
    <Header class="m-pc" :extras="extras" platform="pc"></Header>
    <div class="m-currency-content">
      <div
        class="m-icon-img"
        :style="{
          display:
            extraItem.extras('successImg.display') == 1 ? 'block' : 'none',
        }"
      >
        <img :src="extraItem.extras('successImg.src')" alt="" />
      </div>
      <div
        class="t-success"
        :style="{
          display:
            extraItem.extras('successTitle.display') == 1 ? 'block' : 'none',
          color: extraItem.extras('successTitle.color'),
          fontSize: pxOrVw(extraItem.extras('successTitle.size')),
          fontWeight:
            extraItem.extras('successTitle.weight') == 'default'
              ? '500'
              : extraItem.extras('successTitle.weight'),
        }"
      >
        {{ extraItem.extras("successTitle.model") || "提交成功" }}
      </div>
      <div
        class="t-success-desc"
        :style="{
          display:
            extraItem.extras('successText.display') == 1 ? 'block' : 'none',
          color: extraItem.extras('successText.color'),
          fontSize: pxOrVw(extraItem.extras('successText.size')),
          fontWeight:
            extraItem.extras('successText.weight') == 'default'
              ? '400'
              : extraItem.extras('successText.weight'),
        }"
      >
        {{
          extraItem.extras("successText.model") || "感谢您的参与，祝您工作愉快"
        }}
      </div>
      <div class="t-success-desc" v-if="hasJoin">
        再次填写，请点击这里<span class="u-again" @click="goIndex">→GO!</span>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import templateMixin from "../../../mixins/question-config";
import successMixin from "../../../mixins/success";
import { URLS } from "fire-wind-water";
export default {
  name: "success",
  mixins: [templateMixin, successMixin],
  components: {
    Header,
  },
  data() {
    return {
      questionnaireId:
        URLS.getURL("questionaryId") || URLS.getHash("questionaryId"),
      isSetting: Number(URLS.getURL("isSetting")),
      hasJoin: 0,
    };
  },
};
</script>

<style scoped></style>
